//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Filters from "./components/Filters.vue";
import Sort from "./components/Sort.vue";
import Query from "./components/Query.vue";
import Result from "./components/Result.vue";

export default {
	name: "LocationSearch",
	components: {
		Sort,
		Query,
		Result,
		Filters
	},
	data() {
		return {
			params: null
		}
	},
	methods: {
		extendType({extend, done}) {
			extend(extended => {
				// if the query string in url includes location param, extend location for search pre-load
				// if not, do not extend location 
				if (this.params.has("location")) {
					const location = this.params.get("location")
					location.length > 5 ? extended.location = location.slice(location.length - 5) : extended.location = location
				}
				if (this.params.has('specialty')) {
					extended.specialty = {
						value: this.params.get("specialty")
					};
				}
				if (this.params.has('locationtype')) {
					extended.locationType = {
						value: this.params.get("locationtype")
					};
				}
				return extended;
			});
			done();
		}
	},
	created() {
		this.params = new URLSearchParams(window.location.search)
	}
};
